import api from "../../../router/api";
import { isValid, waitSeconds, cookieManager } from "../../utilitiesmodule";
import { ClientMessage, ONEServiceType } from "../../objects";
import { GraphClient } from "./graphClient";
import { CLOUD_MESSAGES } from "../../messages";

//import { PublicClientApplication } from "@azure/msal-browser";
const methodName = "cloudmethods";
export class AzureClient {

    /**
     * il service account deve contenere : 
        - options.appName : ..., (required)
                oppure
        - options.tenant_id: ..., (required)
        - client_id: ..., (appID) (required)
        - client_secret : ... (optional)
        - refresh_token: ..., (optional)
    }
*/
    constructor(serviceAccount) {
        this.serviceAccount = serviceAccount;
    }

    /**
     * Esegue una richiesta e centralizza il recupero dagli errori Azure.
     * requestFactory viene rivalutata a ogni tentativo, in modo da usare
     * l'eventuale token aggiornato da _catchError.
     */
    async _sendRequestToServer(requestFactory, options = {}) {
        const {
            retries = 1,
            recoverAuthentication = true,
            retryOnFailure = false,
            retryDelaySeconds = 0
        } = options;
        const maxAttempts = Math.max(1, retries + 1);
        let result = [false, null];

        for (let attempt = 1; attempt <= maxAttempts; attempt++) {
            result = await api.sendRequestToServer(...requestFactory(attempt));
            const [ok, response] = result;
            if (ok || attempt == maxAttempts) {
                return result;
            }

            let canRetry = retryOnFailure;
            if (recoverAuthentication) {
                canRetry = await this._catchError(response) || canRetry;
            }
            if (!canRetry) {
                return result;
            }

            if (retryDelaySeconds > 0) {
                await waitSeconds(retryDelaySeconds);
            }
        }

        return result;
    }


    async getTokens() {
        api.emitFunction("sendClientMessage", ClientMessage.wait(CLOUD_MESSAGES.AUTH_IN_PROGRESS), methodName);
        //Step 1 : Chiedo il nuovo token
        //Se è il primo avvio, si richiederà il token con l'authentication code
        //Se non è il primo avvio, è presente sicuramente un token, quindi viene provato
        //Se il token salvato fallisce ed è presente un refresh token, viene richiesto tramite quest'ultimo
        //Se il token salvato fallisce ed è presente un client secret, viene richiesto tramite quest'ultimo
        //Se il token salvato fallisce, viene richiesto con l'authentication code
        var ok = await this._getTokens();

        if (!ok) {
            api.emitFunction("sendClientMessage", ClientMessage.error(CLOUD_MESSAGES.AUTH_NOT_OK, null, methodName, false), methodName);
            return false;
        }

        api.emitFunction("sendClientMessage", ClientMessage.success(CLOUD_MESSAGES.AUTH_OK, null, methodName, false), methodName);

        /***************************TENANTID****************************************************/
        //Step 2 : Se non ho il tenantID, lo recupero
        // if (ok&&!isValid(this.serviceAccount.options.tenant_id)) {
        //     ok=await this._getTenantID(this.serviceAccount.token);
        //     // Step 2.1 : Nel caso in cui la richiesta non va a buon fine, resetto tutti i campi della richiesta e la ritorno
        //     if (!ok) {
        //         this.serviceAccount.token=null;
        //         this.serviceAccount.refresh_token=null
        //         return false;
        //     }
        // }


        //***************************CLIENTID****************************************************/
        //Step 7 : Se non è stato passato un client id, lo ricavo prendendo l'applicazione con il nome passato
        // if (ok&&!isValid(this.serviceAccount.client_id)) {
        //     ok=await this._getApp(this.serviceAccount.options["objID"], null, this.serviceAccount.options["appName"], this.serviceAccount.token);
        //     //Step 7.1 : Se non esiste l'applicazione con il nome passato, creo l'applicazione
        //     if (!ok) {
        //         ok=await this._createNewApp(this.serviceAccount.options["appName"], this.serviceAccount.token);
        //     }
        // }

        /***************************CLIENT SECRET*************************************************************************************/
        if (ok && !isValid(this.serviceAccount.client_secret)) {
            ok = await this._createClientSecret();
            if (!ok) {
                return false;
            }

            ok = await this._getAccessTokenWithAppIDAndClientSecret(this.serviceAccount.options.tenant_id, this.serviceAccount.client_id, this.serviceAccount.client_secret);
            if (!ok) {
                return false;
            }
        }

        if (!ok) {
            return false;
        }

        /***************************REDIRECT URIS + PERMESSI*************************************************************************************/
        ok = await this.checkChanges();

        if (!ok) {
            return false;
        }

        if (this.serviceAccount.type == ONEServiceType.Cloud_OneDrive && !isValid(this.serviceAccount.options.userID)) {
            var graph = new GraphClient(this.serviceAccount);
            var user = await graph.getUserByEmail(this.serviceAccount.username);
            if (user == null)
                return false;
            this.serviceAccount.options["userID"] = user.resID;
            var drive = await graph.getDriveByUserID(user.resID);
            if (drive == null) {
                return this._emitClientError(messages.driveRetrievalFailed);
            }
            this.serviceAccount.options["driveID"] = drive.id;
        }

        return ok;
    }

    //Nuova versione in cui l'utente
    // 1 - Ha già registrato manualmente l'app
    // 2 - ha fornito username, appname, clientid, objID e tenantid
    async _getTokens(firstAccess = true, tryAccessToken = true, tryRefreshToken = true, tryClientSecret = true) {
        var ok = false;
        var hasTenantID = isValid(this.serviceAccount.options.tenant_id);
        var hasToken = isValid(this.serviceAccount.token);
        var hasRefreshToken = isValid(this.serviceAccount.refresh_token);
        var hasAppID = isValid(this.serviceAccount.client_id);
        var hasClientSecret = isValid(this.serviceAccount.client_secret);

        /**********************************TOKEN********************************************************/
        if (hasToken) {
            ok = await this._getTenantID(this.serviceAccount.token);
            if (ok) {
                return true;
            }
            return await this._getTokens();
        }

        /**********************************REFRESH TOKEN********************************************************/
        if (!hasToken && hasRefreshToken) {
            ok = await this._getTokensWithRefreshToken(this.serviceAccount.options.tenant_id, this.serviceAccount.client_id, this.serviceAccount.refresh_token)
            if (ok) {
                return ok;
            }
            return await this._getTokens();
        }

        /**********************************CLIENT SECRET********************************************************/
        //Step 2 : Se non ho alcun token ma ho il client secret, provo la richiesta
        if (!hasToken && !hasRefreshToken && hasClientSecret) {
            ok = await this._getAccessTokenWithAppIDAndClientSecret(this.serviceAccount.options.tenant_id, this.serviceAccount.client_id, this.serviceAccount.client_secret);
            if (ok) {
                return ok;
            }
            return await this._getTokens();
        }

        /**********************************TENANT ID + APPID********************************************************/
        //Step 1 : Se non ho alcun token, lo prendo tramite l'autentication code
        if (!hasToken && !hasRefreshToken && !hasClientSecret && hasTenantID && hasAppID) {
            ok = await this._getTokensWithTenantIDAndAppID(this.serviceAccount.options.tenant_id, this.serviceAccount.client_id);
            return ok;
        }

        // if (!hasToken&&!hasRefreshToken&&!hasClientSecret&&!hasTenantID&&!hasAppID) {
        //     var azureCredentials=getDefaultAzureCredentials();
        //     ok=await this._getTokensWithTenantIDAndAppID(azureCredentials.tenantID, azureCredentials.appID);
        //     if (!ok) {
        //         this.serviceAccount.token=null;
        //         this.serviceAccount.refresh_token=null
        //         return false;
        //     }
        //     return ok;
        // }

        return false;
    }


    async _getTokensWithTenantIDAndAppID(tenantID, appID) {
        //Step 1 : Acquisisco l'authorization code
        var authCode = await this._getAuthCode(tenantID, appID);

        if (authCode == null) return false;

        var ok = await this._getTokensWithAuthorizationCode(tenantID, appID, authCode);

        return ok;
    }

    async _getAuthCode(tenantID, appID) {
        cookieManager.deleteCookie("authCode");
        var scope = "openid profile email offline_access https://graph.microsoft.com/Application.ReadWrite.All";// https://graph.microsoft.com/.default" /*getDefaultScopes().join(" ")*/;
        var queryParams = [
            "client_id=" + appID,
            "scope=" + encodeURIComponent(scope),
            "redirect_uri=" + encodeURIComponent(window.location.origin/*this.serviceAccount.url*/),
            "response_mode=query",
            "response_type=code"
        ];

        var codeVerifier = generateCodeVerifier();
        var codeChallenge = await generateCodeChallenge(codeVerifier);
        sessionStorage.setItem("code_verifier", codeVerifier);
        queryParams.push(...[
            "code_challenge=" + codeChallenge,
            "code_challenge_method=S256"
        ]);

        //Step 2 : Richiedo l'authorization code. Questo verrà concatenato all'url del redirect uri.
        var url = "https://login.microsoftonline.com/{0}/oauth2/v2.0/authorize?{1}".format(tenantID, queryParams.join("&"));

        //console.log(url);
        window.open(url);

        //Step 3 : La pagina specificata nel redirect uri scriverà un cookie contenente l'authCode.
        var authCode = await cookieManager.waitAndGetCookie("authCode");
        if (authCode == null) {
            return null;
        }

        return authCode;

    }

    async _getTokensWithAuthorizationCode(tenantID, appID, authCode) {

        /**
         * 
         * 
        {
            "client_id": "93a1bf1c-a4e3-4e50-9b01-222741230fac",
            "scope": "https://graph.microsoft.com/mail.read",
            "redirect_uri": "https://one.iperiusbeta.com",
            "grant_type": "authorization_code",
            "client_secret": "JqQX2PNo9bpM0uEihUPzyrh",
            "code": "1.AToAhsL6uAnLGUa56AkprdJr7hy_oZPjpFBOmwEiJxQjD6w6AMI6AA.AgABAAIAAAABVrspeuWamRam2jAF1XRQEAwDs_wU...",
            "resource": "https://graph.microsoft.com",
            "code_verifier": "eAcGZTU2qzi2LEMcCjvHzyA0uq8HC1fsJFhIWhgENGO"
        }
         * 
         */
        var body = {
            client_id: appID,
            grant_type: "authorization_code",
            code: authCode,
            redirect_uri: window.location.origin,
        };

        var codeVerifier = sessionStorage.getItem("code_verifier");
        if (!isValid(codeVerifier)) {
            return false;
        }
        body.code_verifier = codeVerifier;


        var [ok, response] = await this._sendRequestToServer(() => [
            "POST",
            GET_TOKEN_URL.format(tenantID),
            defaultHeaders,
            body,
            messages.tryLoginWithAuthenticationCode,
            messages.tryLoginWithAuthenticationCode_ok,
            messages.tryLoginWithAuthenticationCode_failed,
            null,
            "testserviceaccount"
        ], { retries: 0, recoverAuthentication: false });


        if (!ok) {
            return false;
        }

        //console.log(response);
        //console.log("✅ Access Token:", response.access_token);
        this.serviceAccount.token = response.access_token;
        this.serviceAccount.refresh_token = response.refresh_token;
        return true;

    }

    async _getTokensWithRefreshToken(tenantID, appID, refreshToken) {
        var body = {
            "client_id": appID,
            "grant_type": "refresh_token",
            "refresh_token": refreshToken,
            "redirect_uri": window.location.origin,
            "scope": "https://graph.microsoft.com/.default openid profile email offline_access https://graph.microsoft.com/Application.ReadWrite.All"

        };

        var [ok, response] = await this._sendRequestToServer(() => [
            "POST",
            GET_TOKEN_URL.format(tenantID),
            defaultHeaders,
            body,
            messages.tryLoginWithRefreshToken,
            messages.tryLoginWithRefreshToken_ok,
            messages.tryLoginWithRefreshToken_failed,
            null,
            "testserviceaccount"
        ], { retries: 0, recoverAuthentication: false });

        //console.log(response);
        if (!ok) {
            this.serviceAccount.token = null;
            this.serviceAccount.refresh_token = null
            return false;
        }

        //Caso 2 : la richiesta è andata a buon fine
        this.serviceAccount.token = response.access_token;
        this.serviceAccount.refresh_token = response.refresh_token
        return true;
    }

    //https://learn.microsoft.com/en-us/azure/active-directory/develop/v2-oauth2-client-creds-grant-flow
    async _getAccessTokenWithAppIDAndClientSecret() {
        var body = {
            "client_id": this.serviceAccount.client_id,
            "client_secret": this.serviceAccount.client_secret,
            "grant_type": "client_credentials",
            "scope": "https://graph.microsoft.com/.default"
        };

        // Azure può impiegare qualche secondo prima di rendere utilizzabile un nuovo client secret.
        const [ok, response] = await this._sendRequestToServer(attempt => [
                "POST",
                GET_TOKEN_URL.format(this.serviceAccount.options.tenant_id),
                defaultHeaders,
                body,
                "Attempt n.{0} : {1}".format(attempt, messages.tryLoginWithClientSecret),
                messages.tryLoginWithClientSecret_ok,
                null,
                null,
                "testserviceaccount"
            ], {
                retries: 9,
                recoverAuthentication: false,
                retryOnFailure: true,
                retryDelaySeconds: 1
            });

        if (ok) {
            this.serviceAccount.token = response.access_token;
            this.serviceAccount.refresh_token = response.refresh_token;
            return true;
        }

        api.emitFunction("sendClientMessage", ClientMessage.error(messages.tryLoginWithClientSecret_failed, null, methodName, false), methodName);
        this.serviceAccount.client_secret = null;
        this.serviceAccount.token = null;
        this.serviceAccount.refresh_token = null
        return false;
    }
    //--------------------------------------------------NON UTILIZZATI--------------------------------------------------------------------------------------------
    // async _getTokensFromAzure() {
    //     var request=getDefaultAzureCredentials();
    //     var ok=await this._getTokensWithTenantIDAndAppID(request.tenantID, request.appID);

    //     if (ok) {
    //         return true;
    //     }
    //     ok=await this._getDeviceCode(request.tenantID, request.appID);
    //     if (!ok)
    //         return false;

    //     ok=await this._getTokensWithDeviceCode(request.tenantID, request.appID, this.serviceAccount.options.deviceCode);

    //     return ok;
    // }


    // async _getDeviceCode(tenantID, appID) {
    //     if (!isValid(tenantID)||!isValid(appID)) {
    //         tenantID=getDefaultAzureCredentials().tenantID;
    //         appID=getDefaultAzureCredentials().appID;
    //     }

    //     var body={
    //         "client_id": appID,
    //         "scope": tenantID=="common"? /*"openid profile offline_access"*/ "https://graph.microsoft.com/.default":getDefaultScopes().join(" ")
    //     };

    //     var [ok, response]=await api.sendRequestToServer(
    //         "POST",
    //         "https://login.microsoftonline.com/{0}/oauth2/v2.0/devicecode".format(tenantID),
    //         defaultHeaders,
    //         body,
    //         messages.deviceCode,
    //         messages.deviceCode_ok,
    //         messages.deviceCode_failed,
    //         null
    //     );

    //     if (!ok) {
    //         return false;
    //     }

    //     //console.log("Go to:", response.verification_uri);
    //     //console.log("Enter this code:", response.user_code);
    //     await new Promise((resolve) => setTimeout(resolve, 20000));

    //     return ok;
    // }

    // async _getTokensWithDeviceCode(tenantID, appID, deviceCode) {
    //     if (!isValid(tenantID)||!isValid(appID)) {
    //         tenantID=getDefaultAzureCredentials().tenantID;
    //         appID=getDefaultAzureCredentials().appID;
    //     }
    //     var ok=false, response=null;
    //     var body={
    //         client_id: appID,
    //         grant_type: "urn:ietf:params:oauth:grant-type:device_code",
    //         device_code: deviceCode
    //     };


    //     for (var a=1; a<=12; a++) {
    //         await new Promise((resolve) => setTimeout(resolve, 5000)); // Attendi 5 secondi tra i tentativi

    //         [ok, response]=await api.sendRequestToServer(
    //             "POST",
    //             GET_TOKEN_URL.format(tenantID),
    //             defaultHeaders,
    //             body,
    //             "Attempt n. {0} : {1}".format(a, messages.tryLoginWithDeviceCode),
    //             messages.tryLoginWithDeviceCode_ok,
    //             null,
    //             null
    //         );

    //         if (ok) {
    //             this.serviceAccount.token=response.access_token;
    //             if (response.refresh_token) {
    //                 this.serviceAccount.refresh_token=response.refresh_token;
    //             }
    //             return true;
    //         }
    //     }
    //     cookieManager.setCookie("step", messages.tryLoginWithDeviceCode_failed);

    //     return false;
    // }
    //----------------------------------------------------------------------------------------------------------------------------------------------------------------


    async checkChanges(retry = true, app = null, appChanges = null) {
        var ok = false;

        if (app == null) {
            app = await this._getApp(this.serviceAccount.options["objID"], this.serviceAccount.client_id, this.serviceAccount.options["appName"]);
        }


        if (app == null && !retry) {
            api.emitFunction("sendClientMessage", ClientMessage.error(messages.applicationRetrievalFailed, null, methodName, false), methodName);
            return false;
        }

        if (app == null && retry) {

            ok = await this._getAccessTokenWithAppIDAndClientSecret();
            if (!ok) {
                return this._emitClientError(messages.applicationAccessTokenRenewalFailed);
            }
            return await this.checkChanges(false);
        }

        ok = await this.checkChanges_redirectURIs(app, true);

        if (ok) {
            ok = await this.checkChanges_permissions(app, true);
        }

        api.emitFunction(
            "sendClientMessage",
            ok
                ? ClientMessage.success(messages.checkChangesOk, null, methodName, false)
                : ClientMessage.error(messages.checkChangesFailed, null, methodName, false),
            methodName
        );

        return ok;
    }

    async checkChanges_redirectURIs(app, retry = true) {
        var isChangedURIs = false;
        var appChanges = {
            "isFallbackPublicClient": true,
        };
        //Per implemetare la retrocompatibilità, controllo se sono stati cambiati alcuni campi
        //REDIRECT URIS
        [window.location.origin, this.serviceAccount.url, "http://localhost:8080", "https://one.iperiusbeta.com"].forEach(uri => {
            if (uri == null) {
                return;
            }
            if (!app.publicClient.redirectUris.includes(uri)) {
                app.publicClient.redirectUris.push(uri);
                isChangedURIs = true;
            }
        });

        if (!isChangedURIs) {
            return true;
        }

        appChanges["publicClient"] = {
            "redirectUris": app.publicClient.redirectUris
        };

        var [ok] = await this._sendRequestToServer(() => [
            "PATCH",
            "https://graph.microsoft.com/v1.0/applications(appId='{0}')".format(this.serviceAccount.client_id),
            {
                "Authorization": "Bearer " + this.serviceAccount.token,
                "Content-Type": "application/json"
            },
            appChanges,
            messages.redirectUrisUpdate,
            messages.redirectUrisUpdateOk,
            messages.redirectUrisUpdateFailed,
            null,
            "testserviceaccount"
        ], { retries: retry ? 1 : 0 });

        if (ok) {
            return true;
        }


        return false;
    }

    _emitClientError(message) {
        api.emitFunction(
            "sendClientMessage",
            ClientMessage.error(message, null, methodName, false),
            methodName
        );
        return false;
    }

    async checkChanges_permissions(app, retry = true) {
        const resourceAppIds = [
            "00000003-0000-0000-c000-000000000000", // Microsoft Graph
            "00000003-0000-0ff1-ce00-000000000000", // SharePoint
            "00000002-0000-0ff1-ce00-000000000000"  // Exchange
        ];

        const requiredPermissions = await this.getRequiredResourceAccess(resourceAppIds);
        if (!Array.isArray(requiredPermissions) || requiredPermissions.length != resourceAppIds.length) {
            return this._emitClientError(messages.requiredPermissionsRetrievalFailed);
        }

        const currentPermissions = Array.isArray(app.requiredResourceAccess)
            ? app.requiredResourceAccess
            : [];
        const mergedPermissions = this._mergeRequiredResourceAccess(currentPermissions, requiredPermissions);
        const isChangedPermissions = this._hasRequiredResourceAccessChanges(currentPermissions, mergedPermissions);

        if (isChangedPermissions) {
            const [updated] = await this._sendRequestToServer(() => [
                "PATCH",
                "https://graph.microsoft.com/v1.0/applications(appId='{0}')".format(this.serviceAccount.client_id),
                {
                    "Authorization": "Bearer " + this.serviceAccount.token,
                    "Content-Type": "application/json"
                },
                { "requiredResourceAccess": mergedPermissions },
                messages.permissionsUpdate,
                messages.permissionsUpdateOk,
                messages.permissionsUpdateFailed,
                null,
                "testserviceaccount"
            ], { retries: retry ? 1 : 0 });

            if (!updated) {
                return false;
            }

            await waitSeconds(10);
            return await this._requestAdminConsent();
        }

        const hasConsent = await this._hasRequiredPermissionsConsent(requiredPermissions);
        if (hasConsent == null) {
            return this._emitClientError(messages.permissionsConsentCheckFailed);
        }

        return hasConsent || await this._requestAdminConsent();
    }

    async getRequiredResourceAccess(resourceAppIds, retry = true) {
        const requiredResources = [];
        this._requiredResourcesMetadata = {};

        const exactPermissions = new Set([
            "offline_access",
            "EWS.AccessAsUser.All",
            "full_access_as_app",
            "AllSites.FullControl",
            "AllSites.Manage",
            "openid",
            "profile"
        ]);
        const allowedPrefixes = [
            "AllSites.", "Application.", "BrowserSiteLists.", "Calendars.",
            "ChannelMember.", "ChannelMessage.", "ChannelSettings.", "Chat.",
            "ChatMember.", "ChatMessage.", "Contacts.",
            "Contacts-OnPremisesSyncBehavior.","DelegatedPermissionGrant.", "Directory.", "Group.",
            "GroupMember.", "ListItems.", "Lists.", "Mail.", "MailboxItem.",
            "MailboxSettings.", "MyFiles.", "OrgContact.", "Sites.", "Tasks.",
            "Team.", "TeamMember.", "TeamSettings.", "Teamwork.", "User."
        ];
        const allowedOperations = [
            ".Create", ".Edit", ".FullControl", ".ImportExport", ".Manage",
            ".Migrate", ".ReadBasic", ".ReadWrite", ".Search",
            ".SelectedOperations", ".Send"
        ];
        const isRequiredPermission = permission => {
            if (!permission || !permission.isEnabled || !permission.value) {
                return false;
            }

            return exactPermissions.has(permission.value) || (
                allowedPrefixes.some(prefix => permission.value.startsWith(prefix)) &&
                allowedOperations.some(operation => permission.value.includes(operation))
            );
        };

        for (const resourceAppId of resourceAppIds) {
            const [ok, response] = await this._sendRequestToServer(() => [
                "GET",
                `https://graph.microsoft.com/v1.0/servicePrincipals(appId='${resourceAppId}')?$select=id,appRoles,oauth2PermissionScopes`,
                {
                    "Authorization": "Bearer " + this.serviceAccount.token,
                    "Content-Type": "application/json"
                }
            ], { retries: retry ? 1 : 0 });

            if (!ok) {
                return null;
            }

            const roles = (response.appRoles || []).filter(isRequiredPermission);
            const scopes = (response.oauth2PermissionScopes || []).filter(isRequiredPermission);
            const resourceAccess = this._uniquePermissions([
                ...roles.map(role => ({ id: role.id, type: "Role" })),
                ...scopes.map(scope => ({ id: scope.id, type: "Scope" }))
            ]);

            this._requiredResourcesMetadata[resourceAppId] = {
                servicePrincipalId: response.id,
                roles: roles.map(role => ({ id: role.id, value: role.value })),
                scopes: scopes.map(scope => ({ id: scope.id, value: scope.value }))
            };
            requiredResources.push({ resourceAppId, resourceAccess });
        }

        return requiredResources;
    }
    // Funzione per ottenere lo "objectId" del service principal di un'app (es: Microsoft Graph)
    async getServicePrincipalId(appId, retry = true) {
        const [ok, res] = await this._sendRequestToServer(() => [
            "GET",
            `https://graph.microsoft.com/v1.0/servicePrincipals?$filter=appId%20eq%20'${appId}'`,
            {
                "Authorization": "Bearer " + this.serviceAccount.token,
                //'Content-Type': 'application/json'
            }
        ], { retries: retry ? 1 : 0 });

        if (ok && res.value && res.value.length != 0) {
            return res.value[0].id;
        }

        return null;

    }
    /***************************************************REGISTAZIONE APP***************************************************************************************/

    // async _createNewApp(appName, accessToken) {

    //     //var application = newAppObj(request.appName, ["userreadwrite", "groupuserreadwrite", "directoryuserreadwrite", "filesuserreadwrite", "offline_access", "full_access_as_app", "mailbox", "sitesuserreadwrite", "email", "openid", "profile")
    //     var application=createAppObj(appName);
    //     var headers=defaultHeaders;
    //     headers.Authorization="Bearer "+accessToken;
    //     headers["Content-Type"]="application/json";
    //     //console.log(application);
    //     var [ok, response]=await api.sendRequestToServer(
    //         "POST",
    //         "https://graph.microsoft.com/v1.0/applications",
    //         headers,
    //         JSON.stringify(application),
    //         messages.appRegistration,
    //         messages.appRegistrationOk,
    //         messages.appRegistrationFailed,
    //         60 //Devo aspettare un po' di tempo prima di effettuare qualche richiesta
    //     );

    //     if (!ok) {
    //         this.serviceAccount.client_id=null;
    //         this.serviceAccount.options["objID"]=null;
    //         return false;
    //     }

    //     this.serviceAccount.client_id=response.appId;
    //     this.serviceAccount.options["objID"]=response.id;
    //     return true;
    // }


    async _getApp(objID, appID, appName, retry = true) {
        var properties = "$select=id,appId,displayName,requiredResourceAccess,web,keyCredentials,passwordCredentials,publicClient";
        var url;
        var multiple = false;
        if (isValid(appID)) {
            url = "https://graph.microsoft.com/v1.0/applications(appId='{0}')?{1}".format(appID, properties);
        } else if (isValid(objID)) {
            url = "https://graph.microsoft.com/v1.0/applications/{0}?{1}".format(objID, properties);
        } else {
            multiple = true;
            url = "https://graph.microsoft.com/v1.0/applications?{0}&$filter={1}'{2}'".format(properties, encodeURIComponent("DisplayName eq "), appName);
        }


        var [ok, response] = await this._sendRequestToServer(() => [
            "GET",
            url,
            { "Authorization": "Bearer " + this.serviceAccount.token },
            null,
            messages.app,
            messages.appOk,
            messages.appFailed,
            null,
            "testserviceaccount"
        ], { retries: retry ? 1 : 0 });

        if (!ok) {
            return null;
        }

        response = response.value ?? response;
        if (multiple && response.length == 0) {
            return null;
        }

        if (multiple) {
            response = response[0];
        }

        this.serviceAccount.options["appName"] = response.displayName;
        this.serviceAccount.options["objID"] = response.id;
        this.serviceAccount.client_id = response.appId;
        this.application = response;
        return response;
    }

    /****************************************RICHIESTE DI ALTRI DATI***************************************************************/
    //La uso come chiamata rapida per testare il token
    async _getTenantID(accessToken) {
        var [ok, response] = await this._sendRequestToServer(() => [
            "GET",
            "https://graph.microsoft.com/v1.0/organization",
            { "Authorization": "Bearer " + accessToken },
            null,
            messages.tenantID,
            messages.tenantIDOk,
            messages.tenantIDFailed,
            null,
            "testserviceaccount"
        ], { retries: 0, recoverAuthentication: false });

        if (ok) {
            this.serviceAccount.options.tenant_id = response.value[0].id;
            return true;
        }

        this.serviceAccount.token = null;
        return null;
    }

    async _createClientSecret(retry = true, cleanupAttempted = false) {
        if (!this.application || this.serviceAccount.options["appName"] == undefined) {
            await this._getApp(null, this.serviceAccount.client_id, null);
        }
        var now = new Date();
        var startDate = now.toISOString();
        now.setUTCFullYear(now.getUTCFullYear() + 100);
        var endDate = now.toISOString();

        var body = {
            "passwordCredential": {
                "displayName": this.serviceAccount.options["appName"] + " " + now.ddMMyyyyHHmmss(),
                "endDateTime": endDate,
                "startDateTime": startDate
            }
        };

        var [ok, response] = await this._sendRequestToServer(() => [
            "POST",
            "https://graph.microsoft.com/v1.0/applications(appId='{0}')/addPassword".format(this.serviceAccount.client_id),
            {
                "Authorization": "Bearer " + this.serviceAccount.token,
                'Content-Type': 'application/json'
            },
            body,
            messages.clientSecret,
            messages.clientSecretOk,
            messages.clientSecretFailed,
            30,
            "testserviceaccount"
        ], { retries: retry ? 1 : 0 });

        if (ok) {
            this.serviceAccount.client_secret = response.secretText;
            return true;
        }

        if (response?.code == "TooManyAppPasswords") {
            if (cleanupAttempted) {
                return this._emitClientError(messages.clientSecretCleanupFailed);
            }
            var oldest_clientSecret = this.application.passwordCredentials.at(-1);

            [ok, response] = await this._sendRequestToServer(() => [
                "POST",
                "https://graph.microsoft.com/v1.0/applications(appId='{0}')/removePassword".format(this.serviceAccount.client_id),
                {
                    "Authorization": "Bearer " + this.serviceAccount.token,
                    'Content-Type': 'application/json'
                },
                {
                    "keyId": oldest_clientSecret.keyId
                }
            ]);

            if (ok) {
                return await this._createClientSecret(retry, true);
            }
            return this._emitClientError(messages.clientSecretCleanupFailed);

        }

        return false;

    }

    /*
    I permessi sono oggetti del tipo:
        "resourceAppId": "00000003-0000-0000-c000-000000000000", //Rappresenta i servizi principali come graph, sharepoint, exchange....
        "resourceAccess": [{ // è la lista dei permessi
                "id": "06da0dbc-49e2-44d2-8312-53f166ab848a",
                "type": "Scope"
            },
            ...
        }],
        
        
    */
    _permissionKey(permission) {
        return permission && permission.id && permission.type
            ? `${permission.type}:${permission.id}`
            : null;
    }

    _uniquePermissions(permissions) {
        const uniquePermissions = new Map();
        for (const permission of permissions || []) {
            const key = this._permissionKey(permission);
            if (key) {
                uniquePermissions.set(key, { id: permission.id, type: permission.type });
            }
        }
        return Array.from(uniquePermissions.values());
    }

    _mergeRequiredResourceAccess(currentResources, requiredResources) {
        const mergedResources = (currentResources || []).map(resource => ({
            resourceAppId: resource.resourceAppId,
            resourceAccess: this._uniquePermissions(resource.resourceAccess)
        }));

        for (const requiredResource of requiredResources || []) {
            const currentResource = mergedResources.find(resource =>
                resource.resourceAppId == requiredResource.resourceAppId
            );

            if (!currentResource) {
                mergedResources.push({
                    resourceAppId: requiredResource.resourceAppId,
                    resourceAccess: this._uniquePermissions(requiredResource.resourceAccess)
                });
                continue;
            }

            currentResource.resourceAccess = this._uniquePermissions([
                ...currentResource.resourceAccess,
                ...(requiredResource.resourceAccess || [])
            ]);
        }

        return mergedResources;
    }

    _hasRequiredResourceAccessChanges(currentResources, requiredResources) {
        if (!Array.isArray(currentResources) || !Array.isArray(requiredResources)) {
            return true;
        }

        if (currentResources.length != requiredResources.length) {
            return true;
        }

        return requiredResources.some(requiredResource => {
            const currentResource = currentResources.find(resource =>
                resource.resourceAppId == requiredResource.resourceAppId
            );
            if (!currentResource) {
                return true;
            }

            const currentPermissionKeys = new Set(
                this._uniquePermissions(currentResource.resourceAccess).map(permission => this._permissionKey(permission))
            );
            const requiredPermissionKeys = new Set(
                this._uniquePermissions(requiredResource.resourceAccess).map(permission => this._permissionKey(permission))
            );

            return currentPermissionKeys.size != requiredPermissionKeys.size ||
                Array.from(requiredPermissionKeys).some(key => !currentPermissionKeys.has(key));
        });
    }

    async _hasRequiredPermissionsConsent(requiredResources) {
        const [clientOk, clientServicePrincipal] = await this._sendRequestToServer(() => [
            "GET",
            `https://graph.microsoft.com/v1.0/servicePrincipals(appId='${this.serviceAccount.client_id}')?$select=id`,
            { "Authorization": "Bearer " + this.serviceAccount.token }
        ]);
        if (!clientOk || !clientServicePrincipal || !clientServicePrincipal.id) {
            return null;
        }

        const [rolesOk, rolesResponse] = await this._sendRequestToServer(() => [
            "GET",
            `https://graph.microsoft.com/v1.0/servicePrincipals/${clientServicePrincipal.id}/appRoleAssignments`,
            { "Authorization": "Bearer " + this.serviceAccount.token }
        ]);
        const filter = encodeURIComponent(`clientId eq '${clientServicePrincipal.id}'`);
        const [scopesOk, scopesResponse] = await this._sendRequestToServer(() => [
            "GET",
            `https://graph.microsoft.com/v1.0/oauth2PermissionGrants?$filter=${filter}`,
            { "Authorization": "Bearer " + this.serviceAccount.token }
        ]);
        if (!rolesOk || !scopesOk) {
            return null;
        }

        const roleAssignments = Array.isArray(rolesResponse.value) ? rolesResponse.value : [];
        const delegatedGrants = Array.isArray(scopesResponse.value) ? scopesResponse.value : [];

        return requiredResources.every(resource => {
            const metadata = this._requiredResourcesMetadata?.[resource.resourceAppId];
            if (!metadata || !metadata.servicePrincipalId) {
                return false;
            }

            const rolesGranted = metadata.roles.every(role =>
                roleAssignments.some(assignment =>
                    assignment.resourceId == metadata.servicePrincipalId &&
                    assignment.appRoleId == role.id
                )
            );
            const grantedScopeValues = new Set(
                delegatedGrants
                    .filter(grant => grant.resourceId == metadata.servicePrincipalId)
                    .flatMap(grant => (grant.scope || "").split(" ").filter(Boolean))
            );
            const scopesGranted = metadata.scopes.every(scope => grantedScopeValues.has(scope.value));

            return rolesGranted && scopesGranted;
        });
    }

    async _requestAdminConsent() {
        cookieManager.deleteCookie("admin_consent");

        const consentState = generateCodeVerifier();
        localStorage.setItem("admin_consent_state", consentState);
        const query = new URLSearchParams({
            client_id: this.serviceAccount.client_id,
            redirect_uri: window.location.origin,
            state: consentState
        });
        const consentWindow = window.open(
            `https://login.microsoftonline.com/${this.serviceAccount.options.tenant_id}/adminconsent?${query.toString()}`,
            "_blank"
        );
        if (!consentWindow) {
            localStorage.removeItem("admin_consent_state");
            return this._emitClientError(messages.adminConsentPopupBlocked);
        }

        const adminConsent = await cookieManager.waitAndGetCookie("admin_consent");
        localStorage.removeItem("admin_consent_state");
        return adminConsent == "true"
            ? true
            : this._emitClientError(messages.adminConsentFailed);
    }

    async _catchError(error) {

        if (!isValid(error) || error.code == undefined) {
            return false;
        }
        var ok;
        if (error.code.indexOf("Authorization_RequestDenied") != -1) {
            ok = await this._getTokensWithTenantIDAndAppID(this.serviceAccount.options.tenant_id, this.serviceAccount.client_id);
        }

        else if (error.code.indexOf("InvalidAuthenticationToken") != -1 || error.code.indexOf("InvalidRequiredResourceAccess") != -1) {
            this.serviceAccount.token = null;
            ok = await this._getTokens();
        }

        if (ok) {
            await waitSeconds(2);
            console.log(error.code + " -> OK")
            return true;
        }

        console.writeError(error.code + " -> NOT OK")

        return false;

    }
}

//"https://outlook.office365.com/EWS.AccessAsUser.All https://outlook.office365.com/Files.ReadWrite.All https://outlook.office365.com/Group.ReadWrite.All https://outlook.office365.com/User.Read https://outlook.office365.com/.default"



const messages = {
    azureAccess: "I'm logging into the Azure platform",
    azureAccessOk: "I logged into the Azure platform",
    azureAccessFailed: "An error occurred while accessing the Azure platform",

    tenantID: "I'm retrieving the tenant ID",
    tenantIDOk: "I got the tenant ID",
    tenantIDFailed: "An error occurred while retrieving your tenant ID",

    app: "I'm retrieving the application",
    appOk: "I got the application",
    appFailed: "An error occurred while retrieving the application",


    appRegistration: "I am registering the new application",
    appRegistrationOk: "I have registered the new application",
    appRegistrationFailed: "An error occurred while registering the new application",

    appUpdated: "The application is updated",

    checkChanges: "I am checking the changes",
    checkChangesOk: "The Azure application was updated successfully",
    checkChangesFailed: "An error occurred while updating the Azure application",
    applicationRetrievalFailed: "An error occurred while retrieving the Azure application",
    applicationAccessTokenRenewalFailed: "The access token could not be renewed while retrieving the Azure application",
    applicationRefreshFailed: "The Azure application could not be reloaded after renewing the access token",
    redirectUrisUpdate: "I am updating the Azure application redirect URIs",
    redirectUrisUpdateOk: "The Azure application redirect URIs were updated successfully",
    redirectUrisUpdateFailed: "An error occurred while updating the Azure application redirect URIs",
    requiredPermissionsRetrievalFailed: "An error occurred while retrieving the required Azure permissions",
    permissionsUpdate: "I am updating the Azure application permissions",
    permissionsUpdateOk: "The Azure application permissions were updated successfully",
    permissionsUpdateFailed: "An error occurred while updating the Azure application permissions",
    permissionsConsentCheckFailed: "An error occurred while checking the Azure application permissions consent",
    adminConsentPopupBlocked: "The browser blocked the Azure administrator consent window",
    adminConsentFailed: "Azure administrator consent was denied or was not completed in time",
    driveRetrievalFailed: "An error occurred while retrieving the OneDrive drive",
    clientSecretCleanupFailed: "An error occurred while removing the expired Azure client secret",

    appAccess: "I'm logging into the new application",
    appAccessOk: "I logged into the new application",
    appAccessFailed: "An error occurred while accessing the new application",

    clientSecret: "I'm registering the new client secret",
    clientSecretOk: "I have registered the new client secret",
    clientSecretFailed: "An error occurred while registering the new client secret",

    credentialsTest: "I validate the credentials",
    credentialsTestOk: "I validated the credentials",
    credentialsTestFailed: "An error occurred while validating your credentials",

    tryLoginWithAuthenticationCode: "I'm logging with authentication code",
    tryLoginWithAuthenticationCode_ok: "I'm logged with authentication code",
    tryLoginWithAuthenticationCode_failed: "An error occurred while logging with authentication code",

    tryLoginWithAccessToken: "I'm logging with saved token",
    tryLoginWithAccessToken_ok: "I'm logged with saved token",
    tryLoginWithAccessToken_failed: "An error occurred while logging with saved token",

    tryLoginWithRefreshToken: "I'm logging with refresh token",
    tryLoginWithRefreshToken_ok: "I'm logged with refresh token",
    tryLoginWithRefreshToken_failed: "An error occurred while logging with refresh token",

    tryLoginWithClientSecret: "I'm logging with client secret",
    tryLoginWithClientSecret_ok: "I'm logged with client secret",
    tryLoginWithClientSecret_failed: "An error occurred while logging with client secret",

    tryLoginWithDeviceCode: "I'm logging with device code",
    tryLoginWithDeviceCode_ok: "I'm logged with device code",
    tryLoginWithDeviceCode_failed: "An error occurred while logging with device code",

    deviceCode: "I am retrieving the device code",
    deviceCode_ok: "I retrieved the device code. Please enter it in the link provided",
    deviceCode_failed: "An error occurred while retrieving the device code"
}

const defaultHeaders = {
    "Content-Type": "application/x-www-form-urlencoded",
    "Access-Control-Allow-Origin": "*" /*window.location.origin*/,
    "Access-Control-Allow-Credentials": false, // true e * non vanno d'accordo
}


// Funzione per generare un Code Verifier casuale (PKCE)
function generateCodeVerifier() {
    const array = new Uint8Array(32);
    window.crypto.getRandomValues(array);
    return btoa(String.fromCharCode.apply(null, array))
        .replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}

// Funzione per calcolare il Code Challenge (SHA-256)
async function generateCodeChallenge(verifier) {
    const encoder = new TextEncoder();
    const data = encoder.encode(verifier);
    const digest = await window.crypto.subtle.digest("SHA-256", data);
    return btoa(String.fromCharCode.apply(null, new Uint8Array(digest)))
        .replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}

const GET_TOKEN_URL = "https://login.microsoftonline.com/{0}/oauth2/v2.0/token";
